// src/pages/NotFound.jsx
//
// Client-side catch-all for any path that doesn't match a real route
// (App.js's <Route path="*">). Covers the case a server-rendered 404
// (backend/src/middleware/publicRender.js) can't: navigating to a bad URL
// via an in-app <Link> click, which never hits the server at all. Kept in
// sync with the server's 404 copy/behaviour (noindex,follow, same "Page
// Not Found" framing) so both paths feel like the same page.
import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Meta from "../Meta";
import { useSiteSettings } from "../lib/useSiteSettings";

export default function NotFound() {
  const settings = useSiteSettings();
  return (
    <>
      <Meta title={`Page Not Found | ${settings.name}`} desc="The page you're looking for doesn't exist." path="/404" robots="noindex,follow" />
      <main className="pt-24 bg-[#02060c] min-h-screen flex items-center justify-center">
        <div className="max-w-lg mx-auto px-6 py-24 text-center">
          <h1 className="text-4xl font-bold text-white mb-3">Page Not Found</h1>
          <p className="text-white/60 mb-6">The page you're looking for doesn't exist. Head back to the homepage or browse our services.</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link to="/" className="inline-flex items-center gap-2 text-[#22d3ee] hover:text-white font-medium transition-colors">
              <ArrowLeft className="w-4 h-4" /> Back to Home
            </Link>
            <Link to="/services" className="inline-flex items-center gap-2 text-[#22d3ee] hover:text-white font-medium transition-colors">
              Browse Services
            </Link>
          </div>
        </div>
      </main>
    </>
  );
}
